import store from '@/store';

export default function requestFinish(link: string, action: 'set' | 'delete') {
  const key = link.replaceAll('/', '');
  if (action === 'set') {
    store.commit('other/setRequestCall', key);
  }

  if (action === 'delete') {
    store.commit('other/deleteRequestCall', key);
  }
}
